import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\">\n<g id=\"icon-pause_Group 1000010899\">\n<rect id=\"icon-pause_Rectangle 543912\" width=\"50\" height=\"50\" rx=\"25\" fill=\"white\" />\n<path id=\"icon-pause_Polygon 37\" d=\"M31.5 22.4019C33.5 23.5566 33.5 26.4434 31.5 27.5981L24 31.9282C22 33.0829 19.5 31.6395 19.5 29.3301L19.5 20.6699C19.5 18.3605 22 16.9171 24 18.0718L31.5 22.4019Z\" fill=\"#B09FD9\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol